import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-message-icon',
  standalone: true,
  templateUrl: './message-icon.component.html',
  styleUrls: ['./message-icon.component.scss']
})
export class MessageIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
